module.exports = __webpack_public_path__ + "20cf2329c42a3937da259dae9e8b2a9f.jpg";